// import '../../mock/discoverydata.js'
// import request from '@/utils/request'
import {selfRequest_getSchoolDetail,getClassify,getArticle} from '@/utils/selfRequest'
// import selfRequest_hoge from '@/utils/selfRequest'


export function selfRequest_gsd(parameter) {
  return selfRequest_getSchoolDetail(parameter)
}

export function selfRequestGetClassify(parameter) {
  return getClassify(parameter)
}

export function selfRequestGetArticle(parameter) {
  return getArticle(parameter)
}